import React from "react";
import { NavLink } from "react-router-dom";

const Link = ({ h, ti, to, children, className }) => {
    return (
        <>
            {to !== undefined ? (
                <NavLink
                    to={to}
                    title={ti}
                    className={`p-0 m-0 ${className}`}
                    href={h}
                >
                    {children}
                </NavLink>
            ) : (
                <a
                    href={h !== undefined ? h : "#"}
                    title={ti}
                    className={className}
                >
                    {children}
                </a>
            )}
        </>
    );
};

export default Link;
